module.exports = __webpack_public_path__ + "img/btn_wallpaper2_txt.43c70de6.png";